import OrderCargoOrderAbandonedListResponse, {
  OrderCargoOrderAbandonedListResponseItemProducer,
  OrderCargoOrderAbandonedListResponseItem,
} from "../../../../../api/raily/order/cargo-order/abandoned/list/order-cargo-order-abandoned-list.response";
import OrderCargoOrderAbandonedList, {
  OrderCargoOrderAbandonedListItem,
  OrderCargoOrderAbandonedListItemProducer,
} from "./order-cargo-order-abandoned-list";

const createProducer = (
  producer: OrderCargoOrderAbandonedListResponseItemProducer,
): OrderCargoOrderAbandonedListItemProducer => {
  return {
    name: producer.name,
  };
};

const createItem = (
  item: OrderCargoOrderAbandonedListResponseItem,
): OrderCargoOrderAbandonedListItem => {
  return {
    dispatch: item.dispatch,
    externalId: item.externalId,
    humanId: item.humanId,
    passengers: item.passengers,
    producer: createProducer(item.producer),
    rideAddresses: item.rideAddresses,
    startTime: item.startTime,
    uuid: item.id,
  };
};

const create = (
  response: OrderCargoOrderAbandonedListResponse,
): OrderCargoOrderAbandonedList => {
  return {
    data: response.data.data.map(createItem),
    totalCount: response.data.totalCount,
  };
};

const orderCargoOrderAbandonedListFactory = { create };

export default orderCargoOrderAbandonedListFactory;
